import React from "react";
import BaseModal from "@components/modals/BaseModal";
import SecondaryButton from "@components/ui/buttons/SecondaryButton";

interface ForceConfirmModalProps {
  title?: string;
  message: React.ReactNode;
  /** Optional extra content (e.g. a "use suggested time" affordance) */
  children?: React.ReactNode;
  confirmLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * Generic block-but-forceable confirmation modal, used when a staff action
 * violates a rule (e.g. invalid RDV slot) but the user is allowed to override.
 * Mirrors the look of MetierMismatchModal/LunchOverlapModal.
 */
export default function ForceConfirmModal({
  title = "Confirmation requise",
  message,
  children,
  confirmLabel = "Forcer",
  onConfirm,
  onCancel,
}: ForceConfirmModalProps) {
  return (
    <BaseModal title={title} onClose={onCancel} width="max-w-lg">
      <div className="flex flex-col gap-4 p-4">
        <div className="text-h3" style={{ fontFamily: "Poppins", color: "#525252" }}>
          {message}
        </div>
        {children}
      </div>

      <div className="border-t p-4 flex flex-row justify-end gap-2">
        <SecondaryButton variant="small" onClick={onCancel}>
          Annuler
        </SecondaryButton>
        <SecondaryButton variant="small" onClick={onConfirm}>
          {confirmLabel}
        </SecondaryButton>
      </div>
    </BaseModal>
  );
}
